import React, {
  Component
} from 'react'
import PropTypes from 'prop-types';
import './index.scss';
import LineTitle from '../LineTitle';
import Swiper from '../Swiper';
import toImg from '../../assets/image/go4@3x.png';

class RecommendProduct extends Component {
  state = {
    images: [],
    activeIndex: 0
  }

  constructor(props) {
    super(props)
    this.changeIndex = this.changeIndex.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      content
    } = nextProps;

    let arr = []
    content.productInfo && content.productInfo.images && content.productInfo.images.forEach(item => {
      if (item.full && item.full.url) {
        arr.push(item.full.url)
      } else if (item.thumbnail && item.thumbnail.url) {
        arr.push(item.thumbnail.url)
      }
    })

    if (arr.length === 0) {
      if (content.image) {
        arr.push(content.image);
      }
    }

    return {
      images: arr,
      activeIndex: prevState.activeIndex
    }
  }

  changeIndex(index) {
    this.setState({
      activeIndex: index * 1
    })
  }

  render() {
    const {
      content,
      index
    } = this.props;

    if (!content) {
      return null;
    }

    const {
      productInfo,
      off,
      activityOffs
    } = content;
    const {
      images,
      activeIndex
    } = this.state;
    let activitys = []
    if (activityOffs) {
      activitys = off ? activityOffs.push(off) : activityOffs
    } else {
      activitys = off ? [off] : []
    }
    return (
      <a href={productInfo ? `/pd/${productInfo.id}/` : ''} className='recommendItem boxshadow'>
        <div
          data-type='recommendProduct'
          data-product={productInfo && productInfo.id || ''}
          data-index={index}
          >
          <div className='threeDotBox'>
            <div className='rightTopDot'></div>
            <div className='rightTopDot'></div>
            <div className='rightTopDot'></div>
          </div>
          <LineTitle title={content.title1} secondTitle={content.title2}></LineTitle>
          <div className='recommendProductInfo'>
            <div className='productImg'>
              <div className='rightSpot'></div>
              <div className='recommendImgBox'>
                {
                  (productInfo && productInfo.colors && productInfo.colors.length > 1) && (
                    <div className='productIntrodInfo'>{productInfo.colors.length}色可选</div>
                  )
                }
                {
                  (productInfo && productInfo.inventoryStatus && productInfo.inventoryStatus) === 'UNAVAILABLE' && <div className='sold_out'>
                    已售罄
                                  </div>
                }
                {
                  images && <Swiper images={images} changeIndex={this.changeIndex}></Swiper>
                }
              </div>
              <div className='dotNumBox'>
                {
                  images && images.length > 1 && images.map((item, index) => {
                    return (
                      <span key={'images_dot_' + index} className={`doteNum ${activeIndex === index ? 'actNum' : ''}`}></span>
                    )
                  })
                }
              </div>
            </div>
            <div className='productNum'>
              <div className='btnInfoBox'>
                <div className='cnPrice'>{productInfo && productInfo.priceTagCN}</div>
                <div className='uPrice'>
                  {productInfo && productInfo.priceTag && productInfo.priceTag.replace('起', '')}
                  <span>{productInfo && productInfo.originalPriceTag && productInfo.originalPriceTag.replace('起', '')}</span>
                </div>
                <div className='activitys'>
                  {
                    activitys.map((item, index) => {
                      return (
                        <>
                          <span className="activitysItem" key={`activitysItem${index}`}>
                            {item}
                          </span>
                          {
                            index !== activitys.length - 1 &&
                            <span className="line"></span>
                          }
                        </>
                      )
                    })
                  }

                </div>
                <div className='buyBtn' >
                  <div className="btnContent">
                    去购买 <img src={toImg} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            content.paragraphs && content.paragraphs.length > 0 && content.paragraphs[0].text && content.paragraphs.map((item, index) => {
              const spans = item.text?.split('\n') || []
              if (!item.text) {
                return null
              }
              return (
                <div key={'paragraph-' + index}>
                  <div className='line'></div>
                  <div className='productIntrodText'>
                    {spans.map((item1, index1) => {
                      return (
                        <div key={'paragraphLine-' + index1}>
                          {item1}
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })
          }
          {
            content.text ? (
              <div className='content_text'>
                {content.text}
              </div>
            ) : null
          }
        </div >
      </a>
    )
  }
}

RecommendProduct.propTypes = {
  recommendations: PropTypes.object
}
export default RecommendProduct